/**
 * 个人基本-修改密码
 * @description 个人基本信息-修改密码
 * @author mll
 * @date 2020-11-12
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { framework_tool } from '@/tool'
import { WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizSwitch,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizAntdForm } from 'wiz-components'
  
let { WizAvatarUpload } = framework_tool
let WizForm = WizAntdForm
let Item = WizForm.Item
let Option = WizSelect.Option
let { TextArea } = WizInput

import { DatePicker, TimePicker, Button } from 'antd';

const { MonthPicker, RangePicker } = DatePicker;


class PasswordForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }


  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let { submit } = this.props
        submit && submit(this.filterParams(values))
      }
    });
  };


  filterParams(obj) {
    var _newPar = {};
    for (var key in obj) {
      if ((obj[key] === false || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
        _newPar[key] = obj[key];
      } else {
        _newPar[key] = obj[key] === 0 ? obj[key] : ''
      }
    }
    return _newPar;
  }

  _formItemLayout = () => {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <WizForm {...this._formItemLayout()} onSubmit={this.handleSubmit}>
        <Item key={'oldPassword'} label={'旧密码'}>
          {getFieldDecorator('oldPassword', {
            rules: [{
              required: true,
              message: '请输入旧密码',
            }],
          })(
            <WizInput
              prefix={<WizIcon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="请输入旧密码"
            />,
          )}
        </Item>
        <Item key={'password'} label={'新密码'}>
          {getFieldDecorator('password', {
            rules: [{
              required: true,
              message: '请输入新密码',
            }, {
              pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,15}$/,
              message: '密码必须包含大小写字母和数字的组合，不能使用特殊字符，长度8-15'
            }],
          })(
            <WizInput
              prefix={<WizIcon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="请输入新密码"
            />,
          )}
        </Item>
        <Item key={'doublePassword'} label={'确认新密码'}>
          {getFieldDecorator('doublePassword', {
            rules: [{
              required: true,
              message: '请确认新密码',
            }, {
              validator: (rule, value, callback) => {
                const { getFieldValue } = this.props.form;
                if (value !== getFieldValue('password')) {
                  callback('两次密码输入不一致')
                }
                callback();
              }
            }],
          })(
            <WizInput
              prefix={<WizIcon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="请确认新密码"
            />,
          )}
        </Item>
        <Item
          wrapperCol={{
            xs: { span: 24, offset: 0 },
            sm: { span: 14, offset: 6 },
          }}
        >
            <Button type="primary" htmlType="submit">
              确认
            </Button><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button onClick={() => { this.props.onCancel() }}>
              取消
            </Button>
        </Item>
      </WizForm>
    );
  }
}

export default WizForm.create()(PasswordForm);

/**
 * 默认值
 */
PasswordForm.defaultProps = {
  userInfo: {},
  onCancel: () => { }
}

/**
 * props入参校验
 */
PasswordForm.propTypes = {
  submit: PropTypes.func,//提交的回调方法
  onCancel: PropTypes.func,//取消的回调方法
}
